import { styled } from '@mui/material';

export const StyledActionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: '1.5rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const StyledScholarshipCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '2rem',

  [theme.breakpoints.up('md')]: {
    justifyContent: 'start',
  },
}));
